import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getEstatesParentsLookups = async () => {
	const { data } = await axios.get(`${API}/app/maintainer/estate_parent/lookups`);
	return data;
};

export const getEstatesParents = async (params) => {
	const { data } = await axios.get(`${API}/app/maintainer/estate_parent/list`, {
		params,
	});
	return data;
};

export const getEstatesParent = async (slug) => {
	const { data } = await axios.get(`${API}/app/maintainer/estate_parent/${slug}`);
	return data;
};

export const saveEstatesParent = async (form, filters = {}) => {
	const payload = { form, filters };
	const { data } = await axios.post(`${API}/app/maintainer/estate_parent/save`, payload);
	return data;
};

export const deleteEstatesParent = async (slug) => {
	const { data } = await axios.delete(`${API}/app/maintainer/estate_parent/${slug}`);
	return data;
};
